import { render, staticRenderFns } from "./Inspiration.vue?vue&type=template&id=5fad0fd2&scoped=true"
import script from "./Inspiration.vue?vue&type=script&lang=js"
export * from "./Inspiration.vue?vue&type=script&lang=js"
import style0 from "./Inspiration.vue?vue&type=style&index=0&id=5fad0fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad0fd2",
  null
  
)

export default component.exports